module.exports = __webpack_public_path__ + "img/logoColor.c0731982.png";